import { _ as e } from "./tslib.es6-7f1b1220.js";
import { c as t, u as a, h as n } from "./lit-element-161a1699.js";
import { p as i, a as r, c as o } from "./decorators-7e9cd43b.js";
import { RealBaseElement as l } from "./BaseElement.esm.min.js";
import { h as s } from "./host.styles-cf05db22.js";
import { e as h } from "./event.decorator-98549cbc.js";
import { i as d } from "./if-defined-123567fc.js";
import "./types-814d68fb.js";
import { numberUndefinedConverter as c } from "./component.utils.esm.min.js";
import "./mixin.utils.esm.min.js";
import { F as u } from "./form-data-handling.mixin-3ddec2ca.js";
import "./dom.utils.esm.min.js";
import { F as p } from "./form-validation.mixin-0a6c3c34.js";
import "./scrollable.directive.esm.min.js";
const m = t`${a(":host,\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n:host([disabled]) ::placeholder {\n  opacity: 1;\n  color: var(--zui-color-textarea-placeholder);\n}\n\n:host {\n  position: relative;\n  --zui-textarea-height: calc(var(--zui-gu) * 10.5);\n  --zui-textarea-width: calc(var(--zui-gu) * 28);\n  ---zui-textarea-textarea-spacing-horizontal: calc(var(--zui-gu) * 2);\n  ---zui-textarea-textarea-spacing-vertical: calc(var(--zui-gu) * 1.375);\n  height: var(--zui-textarea-height);\n  width: var(--zui-textarea-width);\n  --zui-textarea-textarea-height: auto;\n}\n\n:host([disabled]) {\n  opacity: var(--zui-disabled-opacity);\n}\n\n:host(:focus),\n*:focus {\n  outline: none;\n}\n\n#container {\n  height: 100%;\n  background: var(--zui-color-second-hierarchy-bg-default-enabled);\n  position: relative;\n}\n\n#bottom-line {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: var(--zui-line-strength-thin);\n  background-color: var(--zui-color-textarea-bottom-line);\n}\n\n:host(:not([disabled]):hover) #bottom-line {\n  background-color: var(--zui-color-textarea-bottom-line-hover);\n  height: var(--zui-line-strength-medium, 2px);\n}\n\n:host(:not([disabled]):not([readonly])) #container:hover {\n  background: var(--zui-color-second-hierarchy-bg-default-hovered);\n}\n\nzui-scrollable-directive {\n  height: 100%;\n  width: 100%;\n  font-size: 0;\n  line-height: 0;\n  --zui-scrollable-content-display-mode: block;\n}\n\ntextarea {\n  line-height: normal;\n  -webkit-appearance: none;\n  appearance: none;\n  background: none;\n  border: none;\n  color: var(--zui-color-text-default);\n  font: var(--zui-typography-body);\n  margin: 0;\n  resize: none;\n  padding: var(---zui-textarea-textarea-spacing-vertical) var(---zui-textarea-textarea-spacing-horizontal);\n  height: var(--zui-textarea-textarea-height);\n  width: 100%;\n}\n\n:host(:focus-within) #bottom-line {\n  height: var(--zui-line-strength-medium, 2px);\n}\n\ntextarea::placeholder {\n  color: var(--zui-color-textarea-placeholder);\n  opacity: unset;\n}\n\n:host([readonly]) #container {\n  background: none;\n}\n\ntextarea:read-only::placeholder,\ntextarea:focus::placeholder {\n  color: transparent;\n  opacity: unset;\n}\n\n:host(:not([disabled])[readonly]) #bottom-line {\n  display: none;\n}")}`;
let v = class extends p(u(l)) {
  constructor() {
    super(), this.value = "", this.required = !1, this._resizeObserver = new ResizeObserver(() => this._handleResize()), this.addValidator({
      type: "valueMissing",
      validator: () => !1 === this.required || !0 !== this._textarea.validity.valueMissing,
      validatesOnProperties: ["required"]
    }), this.addValidator({
      type: "tooShort",
      validator: () => !this.minlength || !this.value || this.value.length >= this.minlength,
      validatesOnProperties: ["minlength"]
    }), this.addValidator({
      type: "tooLong",
      validator: () => !this.maxlength && 0 !== this.maxlength || !this.value || this.value.length <= this.maxlength,
      validatesOnProperties: ["maxlength"]
    });
  }
  static get styles() {
    return [s, m];
  }
  emitInputEvent() {}
  emitChangeEvent() {
    this.dispatchEvent(new Event("change", {
      bubbles: !0,
      cancelable: !1,
      composed: !1
    }));
  }
  connectedCallback() {
    super.connectedCallback(), this._resizeObserver.observe(this);
  }
  disconnectedCallback() {
    this._resizeObserver.disconnect(), super.disconnectedCallback();
  }
  _handleResize() {
    this._resizeTextarea();
  }
  _resizeTextarea() {
    this._textarea.style.setProperty("--zui-textarea-textarea-height", "auto");
    const e = this._textarea.scrollHeight,
      t = Math.max(this.offsetHeight, e);
    this._textarea.style.setProperty("--zui-textarea-textarea-height", `${t}px`);
  }
  _handleTextareaInput() {
    this.value = this._textarea.value;
  }
  _handleTextareaChange() {
    this.emitChangeEvent();
  }
  updated(e) {
    super.updated(e), (e.has("value") || e.has("placeholder")) && this._resizeTextarea();
  }
  render() {
    return n`<div id="container"><zui-scrollable-directive background="visible" hitarea="enlarged"><textarea ?disabled="${this.disabled}" ?readonly="${this.readonly}" ?required="${this.required}" maxlength="${d(this.maxlength)}" minlength="${d(this.minlength)}" name="${this.name}" placeholder="${d(this.placeholder)}" @input="${this._handleTextareaInput}" @change="${this._handleTextareaChange}" .value="${d(this.value)}"></textarea></zui-scrollable-directive></div><div id="bottom-line"></div>`;
  }
};
e([i({
  reflect: !0
})], v.prototype, "placeholder", void 0), e([i({
  reflect: !0
})], v.prototype, "value", void 0), e([i({
  reflect: !0,
  type: Boolean
})], v.prototype, "required", void 0), e([i({
  reflect: !0,
  converter: c
})], v.prototype, "minlength", void 0), e([i({
  reflect: !0,
  converter: c
})], v.prototype, "maxlength", void 0), e([h()], v.prototype, "emitInputEvent", null), e([h()], v.prototype, "emitChangeEvent", null), e([r("zui-scrollable-directive")], v.prototype, "_scrollableDirective", void 0), e([r("textarea")], v.prototype, "_textarea", void 0), v = e([o("zui-textarea")], v);
let g = class extends v {
  connectedCallback() {
    super.connectedCallback(), console.warn("The usage of <zui-comment> has been deprecated and it will be removed in the next major release! It has been renamed to <zui-textarea>");
  }
};
g = e([o("zui-comment")], g);
export { g as Comment, v as Textarea };
